import { IconBase, IconComponent } from './BaseIcon';

export const FullscreenOn: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="m11 18.8-7.8 7.7v-4.1H0V32h9.6v-3.2H5.4l7.8-7.8-2.2-2.2ZM22.4 0v3.2h4.1L18.7 11l2.3 2.3 7.8-7.9v4.2H32V0h-9.6Z" />
  </IconBase>
);
